// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e0f7a677","455":"1a4cef4f"}[chunkId] + ".chunk.js";
};